module.exports = __webpack_public_path__ + "img/telegram.c2a238a6.svg";